import React from 'react';
import { useNavigate } from 'react-router-dom';
import ButtonComp from '@components/UI/Button/Index';

const AcessoNegado = () => {
    const navigate = useNavigate();

    const handleGoHome = () => {
        navigate('/');
    };

    return (
        <div className="d-flex flex-column justify-content-center align-items-center vh-100">
            <div className="text-center">
                <div>
                    <h1 className="display-1 fw-bold">403</h1>
                </div>
                <div className='mt-3'>
                    <h2 className='display-6 fw-bold'>Acesso Negado</h2>
                </div>
                <div className="mt-3">
                    <h2>Você não tem permissão para acessar essa página.</h2>
                </div>
                <div className='mt-3 btn'>
                    <ButtonComp
                        title={"VOLTAR PARA A HOME"}
                        className="btn btn-primary"
                        onClick={handleGoHome}
                        buttonColor={"#2b97be"}
                        classnameIcon={"fa-solid fa-backward"}
                        hoverMessage={"Botão para voltar para a página home"}
                    />
                </div>
            </div>
        </div>
    );
};

export default AcessoNegado;
